import { useEffect } from "react";

const scripts = {
  playerUrlV0: "https://cdn.ampproject.org/amp-story-player-v0.js",
  playerUrlV01: "https://cdn.ampproject.org/v0/amp-story-player-0.1.js",
};

function loadScript(scriptName) {
  const script = document.createElement("script");
  script.async = true;
  script.id = scriptName;
  script.src = scripts[scriptName];
  return script;
}

const useGWSScript = () => {

  useEffect(() => {
    const playerScriptV0 = document.getElementById("playerUrlV0");
    const playerScriptV01 = document.getElementById("playerUrlV01");

    if (!playerScriptV0) {
      const script = loadScript("playerUrlV0");
      document.body.appendChild(script);
    }

    if (!playerScriptV01) {
      const ampJs = loadScript("playerUrlV01");
      ampJs.setAttribute("custom-element", "amp-story-player");
      document.body.appendChild(ampJs);
    }

  }, []);
};

export default useGWSScript;
